import { useSingleSeriesQuery } from './useSingleSeriesQuery';
export const useSingleSeries = (id) => {
    const { singleSeriesQuery } = useSingleSeriesQuery([id]);
    return {
        singleSeriesQuery,
        singleSeries: singleSeriesQuery.data,
    };
};
